import { Controller } from "@hotwired/stimulus";
class default_1 extends Controller {
    constructor() {
        super(...arguments);
        this.lastSortedColumn = null;
        this.isAscending = true;
    }
    sort(event) {
        const th = event.currentTarget;
        const column = parseInt(th.dataset.column || "0");
        const table = this.tableTarget;
        const tbody = table.querySelector("tbody") || table.querySelector("[data-table-sort-target='body']");
        if (!tbody)
            return;
        const rows = Array.from(tbody.querySelectorAll("tr")).length > 0
            ? Array.from(tbody.querySelectorAll("tr"))
            : Array.from(tbody.querySelectorAll("[data-table-sort-target='row']"));
        const isAscending = this.lastSortedColumn === column ? !this.isAscending : true;
        rows.sort((a, b) => {
            const aCol = a.children[column];
            const bCol = b.children[column];
            const aText = aCol?.dataset.sortValue ?? aCol?.textContent?.trim() ?? "";
            const bText = bCol?.dataset.sortValue ?? bCol?.textContent?.trim() ?? "";
            const aValue = isNaN(parseFloat(aText)) ? aText : parseFloat(aText);
            const bValue = isNaN(parseFloat(bText)) ? bText : parseFloat(bText);
            if (aValue < bValue)
                return isAscending ? -1 : 1;
            if (aValue > bValue)
                return isAscending ? 1 : -1;
            return 0;
        });
        rows.forEach(row => tbody.appendChild(row));
        this.lastSortedColumn = column;
        this.isAscending = isAscending;
        this.updateIcons(column, isAscending);
    }
    updateIcons(column, isAscending) {
        const headers = this.tableTarget.querySelectorAll("th, [data-table-sort-target='header']");
        headers.forEach((th, index) => {
            let icon = th.querySelector(".sort-icon");
            if (!icon)
                return;
            if (index === column) {
                icon.innerHTML = isAscending ? "↑" : "↓";
                th.classList.add("text-primary");
                icon.classList.remove("text-muted");
                icon.classList.add("text-primary");
            }
            else {
                icon.innerHTML = "↕";
                th.classList.remove("text-primary");
                icon.classList.remove("text-primary");
                icon.classList.add("text-muted");
            }
        });
    }
}
default_1.targets = ["table"];
export default default_1;
